<template>
  <v-card class="pa-4">
    <v-card-text class="pb-0">
      <p class="pa-3 mb-0">
        Are you sure you want to delete the Dashboard card for <span class="font-weight-bold">{{ deleteLabelDashboard }}</span>?
      </p>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn
        color="coolgray"
        text
        @click.stop="cancelDeleteDashboard"
      >
        Cancel
      </v-btn>

      <v-btn
        color="toasted"
        text
        @click.stop="deleteDashboardAndResetForm(deleteIndexDashboard)"
      >
        Delete it
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DashboardMixin from 'src/dashboard/store/utils/dashboard-mixin'

export default {
  name: 'DashboardDelete',
  mixins: [
    DashboardMixin,
  ],
}
</script>
